import request from '@/utils/request'
import request_py from '@/utils/request_py'
import request_py2 from '@/utils/request_py_v2'

export function getTreatmentStandardList(params) {
  return request({
    url: '/query/getTreatmentStandardList',
    method: 'get',
    params: params
  })
}

export function getTreatmentStandardList_py(params) {
  return request_py({
    url: '/treatment/getTreatmentStandardList',
    method: 'get',
    params: params
  })
}

export function putTreatmentStandardInit(data) {
  return request({
    url: '/treatment_standard/init',
    method: 'put',
    data: data
  })
}

export function putTreatmentStandardChange(data) {
  return request({
    url: '/treatment_standard/change',
    method: 'put',
    data: data
  })
}

export function putTreatmentStandardChange_py(data) {
  return request_py({
    url: '/treatment/treatment_standard',
    method: 'put',
    data: data
  })
}

export function delFamilyAssets(params) {
  return request({
    url: '/family_assets',
    method: 'delete',
    params: params
  })
}

export function putTreatmentStandardPaper(data) {
  return request({
    url: '/treatment_standard/paper',
    method: 'put',
    data: data
  })
}

export function putTreatmentStandardSubsidySetup(data) {
  return request({
    url: '/treatment_standard/subsidy_setup',
    method: 'put',
    data: data
  })
}

export function getSuccourTypeTreatmentStandardSubsidySetup(params) {
  return request_py({
    url: '/pc_ext/get_subsidy_setup',
    method: 'get',
    params
  })
}

export function getTemporaryStatsProcess() {
  return request_py2({
    url: '/temporary/stats/process',
    method: 'get',
  })
}

export function getTemporaryStatsProcessDetail(params) {
  return request_py2({
    url: '/temporary/stats/process/detail',
    method: 'get',
    params
  })
}

export function getTemporaryStatsProcessFinish() {
  return request_py2({
    url: '/temporary/stats/finish',
    method: 'get',
  })
}

export function getTemporaryStatsProcessFinishDetail(params) {
  return request_py2({
    url: '/temporary/stats/finish/detail',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/treatment_standard.js